export default "__VITE_ASSET__2f92ec5a__"